/* eslint-disable @typescript-eslint/no-unsafe-function-type */
import {
	Exclude,
	Expose,
	instanceToPlain,
	plainToClassFromExist,
	plainToInstance,
	TransformationType,
	TransformFnParams,
} from 'class-transformer';
// eslint-disable-next-line no-restricted-imports
import { isArray } from '../../../compare';
import { FieldModel } from './field.model';

export class FieldContainerModel<T> extends FieldModel {
	@Exclude({ toPlainOnly: true })
	private _genericType: Function;

	@Exclude()
	private _subfields: T;

	constructor(genericType: Function) {
		super();
		this._genericType = genericType;
	}

	@Expose()
	get subfields(): T {
		return this._subfields;
	}
	set subfields(value: T) {
		if (isArray(value)) {
			this._subfields = value;
		} else {
			this._subfields = plainToInstance(this._genericType(), value);
		}
	}
}

export function FieldContainerModel_ClassTransform_TransformFactory<T>(
	genericType: () => T,
) {
	return (params: TransformFnParams) => {
		if (params.type === TransformationType.PLAIN_TO_CLASS) {
			if (isArray(params.value)) {
				return params.value.map((v) => {
					return plainToClassFromExist(
						new FieldContainerModel<T>(genericType),
						v,
					);
				});
			} else {
				return plainToClassFromExist(
					new FieldContainerModel<T>(genericType),
					params.value,
				);
			}
		} else if (params.type === TransformationType.CLASS_TO_PLAIN) {
			return instanceToPlain(params.value);
		} else if (params.type === TransformationType.CLASS_TO_CLASS) {
			if (isArray(params.value)) {
				return params.value.map((v) => {
					return plainToClassFromExist(
						new FieldContainerModel<T>(genericType),
						instanceToPlain(v),
					);
				});
			} else {
				return plainToClassFromExist(
					new FieldContainerModel<T>(genericType),
					instanceToPlain(params.value),
				);
			}
		} else {
			return params.value;
		}
	};
}
